import { Typography } from "@mui/material";

export const LoadingComponent = () => {
  return <Typography variant="h6">Authentication in progress...</Typography>;
};
